import {
	Typography,
	Stack,
	Icon,
	Tooltip,
	ListItem,
	ListItemIcon,
	Alert,
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as AddNewIcon } from 'common/assets/images/addnew.svg';
import { ReactComponent as DeleteIcon } from 'common/assets/images/delete-icon.svg';
import { ReactComponent as DownchevronIcon } from 'common/assets/images/downchevron.svg';
import { ReactComponent as EditIcon } from 'common/assets/images/edit-Icon.svg';
import { ReactComponent as OrderIcon } from 'common/assets/images/order-icon.svg';
import { ReactComponent as UpchevronIcon } from 'common/assets/images/upchevron.svg';
import { ReactComponent as WarningIcon } from 'common/assets/images/warning.svg';
import SideDrawer from 'common/components/SideDrawer/SideDrawer';
import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import TableComponent from 'common/components/Table/Table';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import {
	APP_GENERAL_ERROR_MSG,
	GENERIC_ERROR_MSG,
} from 'common/constants/TextContent';
import { WORKFLOW_TEXT_CONSTANTS } from 'common/constants/WorkflowConstants';
import { RootState } from 'common/store/AppStore';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import {
	setWorkflowStepDetails,
	setWorkflowStepDrawer,
	setWorkflowStepFlag,
} from 'common/store/reducer/workflowReducer';
import {
	dateInCorrectFormatWithFullYear,
	swapArrayObjects,
	toSentenceCase,
	truncateString,
} from 'common/utils/utilFunctions';

import useTableQuery from 'hooks/useTableQuery';

import ActionsPrompt from './ActionsPrompt';
import {
	deleteWorkFlowStep,
	getAllWorkflowList,
	getWorkflowStepData,
	updatedWorkflowStepOrder,
} from './api';
import { WorkflowListItemStepsContentResponse } from './api/type-def';
import WorkflowStep from './WorkflowStep/WorkflowStep';

import styles from './WorkflowList.module.scss';

const {
	WORKFLOW_STEP_DELETED,
	DELETE_CONFIRMATION,
	DELETE_TITLE,
	DELETE_SUB_TITLE,
	DELETE_BUTTON_CANCEL_LABEL,
	DELETE_BUTTON_LABEL,
} = WORKFLOW_TEXT_CONSTANTS;

const { OK, NOT_FOUND } = HTTP_STATUS_CODES;

const WorkflowList: React.FC = () => {
	const { statusWarningColor, textColor, alertBackgroundColor, iconFillColor } =
		styles;

	const dispatch = useDispatch();

	const [allWorkflowList, setAllWorkflowList] = useState<any>([]);
	const [isLoading, setLoading] = useState<boolean>(false);
	const [hoverIcon, setChildHoverIcon] = useState<boolean>(false);
	const [isToastOpen, setToastOpen] = useState<boolean>(false);
	const [selectedWorkFlowStepChildIndex, setSelectedChildWorkFlowIndex] =
		useState<string>('');
	const [parentHoverIcon, setParentHoverIcon] = useState<boolean>(false);
	const [selectedWorkflowParentIndex, setselectedWorkflowParentIndex] =
		useState<string>('');
	const [totalPagesCount, setTotalPagesCount] = useState(0);
	const [totalRecordsCount, setTotalRecordsCount] = useState<number>(0);
	const [selectedFromObj, setSelectedFromObj] = useState<any>();
	const [openActionsModal, setOpenActionsModal] = useState<boolean>(false);
	const [selectedWorkFlowStep, setSelectedWorkFlowStep] = useState<any>();

	const { severity, message } = useSelector(
		(state: RootState) => state.common.toastMessage,
	);

	const { tableQueryObj, updateTableQuery } = useTableQuery({
		id: 'WorkflowListTable',
	});
	const openWorkflowDrawer = useSelector(
		(state: RootState) => state.workflowmodule.workflowStepDrawer,
	);
	const createWorkflowStepFlag = useSelector(
		(state: RootState) => state.workflowmodule.createWorkflowStepFlag,
	);

	const openWorkflowDetailsPage = (val: any) => {
		dispatch(
			setWorkflowStepDetails({
				type: 'create',
				data: val,
			}),
		);

		dispatch(setWorkflowStepDrawer(true));
	};
	const workflowListColumns: Column[] = [
		{
			id: 'workflowName',
			label: 'Workflow',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div className={styles['workflow-list-field']}>
					<Icon
						sx={{
							'&.MuiIcon-root': {
								fontSize: '1rem !important',
								marginRight: '1.25rem',
							},
						}}
						aria-label="accordion"
						data-testid="parent-expand"
						onClick={() => {
							handleExpand(params);
						}}
						className={styles['workflow-icon-actions-expand']}
					>
						{params && params.expand ? (
							<UpchevronIcon
								fill={iconFillColor}
								className={styles['workflow-list-icon']}
							/>
						) : (
							<DownchevronIcon
								fill={iconFillColor}
								className={styles['workflow-list-icon']}
							/>
						)}
					</Icon>
					<Typography
						className={styles['workflow-list-parentname']}
						data-testid="workflow-list-parentname"
					>
						{params?.workflowName}
					</Typography>
				</div>
			),
		},
		{
			id: 'modifiedDate',
			label: 'Last Updated Date',
			disablePadding: false,
			isSortable: true,
			render: (params: any) => (
				<div>
					{params?.modifiedDate &&
						dateInCorrectFormatWithFullYear(params?.modifiedDate)}
				</div>
			),
		},
		{
			id: 'workflowId',
			label: 'Action',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<ListItem
					data-testid="add-ele"
					onMouseOver={() => {
						setParentListHover(params.workflowId);
					}}
					onFocus={() => {
						setParentListHover(params.workflowId);
					}}
					onMouseOut={() => {
						onHideParentListIcons();
					}}
					onBlur={() => {
						onHideParentListIcons();
					}}
					className={styles['workflow-icon-actions']}
				>
					{parentHoverIcon &&
					selectedWorkflowParentIndex === params.workflowId ? (
						<ListItemIcon
							sx={{
								'& :hover': {
									cursor: 'pointer',
								},
							}}
						>
							<Tooltip
								title={toSentenceCase('Add Workflow Step')}
								placement="right-start"
								data-testid="addnew-tooltip"
								className={styles['info-icon']}
							>
								<Icon data-testid="add-icon">
									<AddNewIcon
										onClick={() => {
											openWorkflowDetailsPage(params);
										}}
										fill={iconFillColor}
										className={styles['workflow-list-icon']}
									/>
								</Icon>
							</Tooltip>
						</ListItemIcon>
					) : null}
				</ListItem>
			),
		},
	];

	const workflowStepsColumns: Column[] = [
		{
			id: 'id',
			label: '',
			disablePadding: false,
			render: (params: any) => (
				<ListItem
					data-testid="main-order-ele"
					className={styles['workflow-icon-order']}
					onMouseOver={() => {
						setChildListHover(params.workflowStepId);
					}}
					onFocus={() => {
						setChildListHover(params.workflowStepId);
					}}
					onMouseOut={() => {
						onHideChildListIcons();
					}}
					onBlur={() => {
						onHideChildListIcons();
					}}
					onDrop={(e) => {
						onChildDropData(e, params);
					}}
					onDragOver={(e) => e.preventDefault()}
					onDragEnd={(e) => e.preventDefault()}
				>
					{hoverIcon &&
					selectedWorkFlowStepChildIndex === params.workflowStepId ? (
						<ListItemIcon>
							<div
								draggable
								onDragStart={(e) => {
									onChildDragData(e, params, params.workflowStepId);
								}}
								data-testid="order-ele"
							>
								<Tooltip
									title="Reorder"
									placement="right-start"
									data-testid="order-tooltip"
									className={styles['info-icon']}
								>
									<OrderIcon
										data-testid="order-icon"
										fill={iconFillColor}
										className={styles['workflow-list-icon']}
									/>
								</Tooltip>
							</div>
						</ListItemIcon>
					) : null}
				</ListItem>
			),
		},
		{
			id: 'workflowStepName',
			label: toSentenceCase('Workflow Steps '),
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<Typography
					className={styles['workflow-list-name']}
					data-testid="workflow-listname"
				>
					{params?.workflowStepName}
				</Typography>
			),
		},
		{
			id: 'asignee',
			label: 'Assignee ',
			disablePadding: false,
			isSortable: false,
			render: ({ asignee }: any) => (
				<Typography>
					{asignee?.length > 10 ? (
						<Tooltip title={asignee}>
							<span>{`${truncateString(asignee, 15)}...`}</span>
						</Tooltip>
					) : (
						asignee
					)}
				</Typography>
			),
		},
		{
			id: 'userCount',
			label: 'Users',
			disablePadding: false,
			isSortable: false,
			render: ({ userCount }: any) => <Typography>{userCount}</Typography>,
		},
		{
			id: 'createdDate',
			label: toSentenceCase('Created Date'),
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<div>
					{params?.createdDate &&
						dateInCorrectFormatWithFullYear(params?.createdDate)}
				</div>
			),
		},
		{
			id: 'modifiedDate',
			label: toSentenceCase('Updated Date'),
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<div>
					{params?.modifiedDate &&
						dateInCorrectFormatWithFullYear(params?.modifiedDate)}
				</div>
			),
		},
		{
			id: 'workflowId',
			label: 'Action',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<ListItem
					className={styles['workflow-icon-actions']}
					data-testid="inner-list-actions"
					onMouseOver={() => {
						setChildListHover(params.workflowStepId);
					}}
					onFocus={() => {
						setChildListHover(params.workflowStepId);
					}}
					onMouseOut={() => {
						onHideChildListIcons();
					}}
					onBlur={() => {
						onHideChildListIcons();
					}}
				>
					{hoverIcon &&
					selectedWorkFlowStepChildIndex === params.workflowStepId ? (
						<ListItemIcon
							sx={{
								'& :hover': {
									cursor: 'allowed',
								},
							}}
						>
							<Stack direction="row" className={styles['workflow-list-item']}>
								<Tooltip
									title="Edit"
									placement="top"
									data-testid="edit-tooltip"
									className={styles['info-icon']}
								>
									<Icon
										data-testid="edit-icon"
										onClick={() => onEditWorkflowStep(params)}
									>
										<EditIcon fill={iconFillColor} />
									</Icon>
								</Tooltip>
								<Tooltip
									title="Delete"
									placement="right-start"
									data-testid="delete-tooltip"
									className={styles['info-icon']}
								>
									<Icon
										onClick={() => onDeleteWorkflow(params)}
										className={styles['workflow-list-item-delete']}
										data-testid="delete-action"
									>
										<DeleteIcon fill={iconFillColor} />
									</Icon>
								</Tooltip>
							</Stack>
						</ListItemIcon>
					) : null}
				</ListItem>
			),
		},
	];

	const onDeleteWorkflow = (data: WorkflowListItemStepsContentResponse) => {
		setSelectedWorkFlowStep(data);
		setOpenActionsModal(true);
	};

	const onEditWorkflowStep = async (data: any) => {
		const params = {
			workflowId: data.workflowId,
			workflowStepId: data.workflowStepId,
		};
		try {
			const resp: any = await getWorkflowStepData(params);
			if (resp?.statusCode === OK) {
				const tempData = resp?.responseBody;
				tempData.workflowId = data.workflowId;
				dispatch(
					setWorkflowStepDetails({
						type: 'edit',
						data: tempData,
					}),
				);

				dispatch(setWorkflowStepDrawer(true));
			} else {
				setLoading(false);
				setToastOpen(true);
				dispatch(
					setToastMessage({
						message: APP_GENERAL_ERROR_MSG,
						severity: 'error',
						isToastOpen: true,
					}),
				);
			}
		} catch (e) {
			setLoading(false);
			setToastOpen(true);
			dispatch(
				setToastMessage({
					message: GENERIC_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};

	const actionHandler = async (data: WorkflowListItemStepsContentResponse) => {
		const resp: any = await deleteWorkFlowStep(data);
		if (resp?.statusCode === OK) {
			setToastOpen(true);
			setOpenActionsModal(false);
			setLoading(false);
			updateStateOnDelete(data);
		} else {
			setOpenActionsModal(false);
			setSelectedWorkFlowStep({});
			setLoading(false);
			setToastOpen(true);
			dispatch(
				setToastMessage({
					message: APP_GENERAL_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};

	const updateStateOnDelete = (data: WorkflowListItemStepsContentResponse) => {
		setAllWorkflowList((prevState: any) => {
			const newState = prevState.map((obj: any) => {
				const tempInnerObj = { ...obj };
				if (obj?.workflowId === data?.workflowId) {
					if (obj?.workflowSteps) {
						const stepsArr = obj?.workflowSteps;
						const filteredArray = stepsArr.filter(
							(ele: any) => ele.workflowStepId !== data.workflowStepId,
						);
						tempInnerObj.workflowSteps = filteredArray;
					}
					return tempInnerObj;
				}
				return tempInnerObj;
			});
			return newState;
		});

		dispatch(
			setToastMessage({
				message: WORKFLOW_STEP_DELETED,
				severity: 'success',
				isToastOpen: true,
			}),
		);
		setSelectedWorkFlowStep({});
	};
	const cancelHandler = () => {
		setOpenActionsModal(false);
		setSelectedWorkFlowStep({});
	};

	const getAllWorkFlowList = async (paramsData: any) => {
		setLoading(true);
		setToastOpen(false);
		const resp: any = await getAllWorkflowList(paramsData);
		if (resp?.statusCode === OK) {
			const result = resp?.responseBody.content;
			result.forEach((ele: any) => {
				const workflowSteps = ele?.workflowSteps;
				if (workflowSteps.length > 0) {
					ele?.workflowSteps.forEach((innerEle: any) => {
						innerEle.workflowId = ele?.workflowId;
					});
				}
			});
			setTotalPagesCount(resp?.responseBody?.totalPages);
			setTotalRecordsCount(resp?.responseBody?.totalCount);
			setAllWorkflowList(result);
			setLoading(false);
		} else if (resp?.statusCode === NOT_FOUND) {
			setLoading(false);
		} else {
			setLoading(false);
			setToastOpen(true);
			dispatch(
				setToastMessage({
					message: APP_GENERAL_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};

	const handleExpand = (params: any) => {
		const tempObj = { ...params };
		tempObj.expand = !tempObj.expand;
		setChildHoverIcon(false);
		setSelectedChildWorkFlowIndex('');
		setAllWorkflowList((prevState: any) => {
			const newState = prevState.map((obj: any) => {
				const tempInnerObj = { ...obj };
				if (obj.workflowId === params.workflowId) {
					return tempObj;
				}
				tempInnerObj.expand = false;
				return tempInnerObj;
			});
			return newState;
		});
	};

	const handlePageChange = (data: any) => {
		updateTableQuery(data);
		getAllWorkFlowList(data);
	};

	const handleSortChange = (data: any) => {
		getAllWorkFlowList(data);
	};

	const setParentListHover = (index: string) => {
		setParentHoverIcon(true);
		setselectedWorkflowParentIndex(index);
	};

	const onHideParentListIcons = () => {
		setParentHoverIcon(false);
	};

	const onChildDragData = (e: any, data: any, index: string) => {
		setSelectedChildWorkFlowIndex(index);
		setSelectedFromObj(data);
	};

	const setChildListHover = (index: string) => {
		setChildHoverIcon(true);
		setSelectedChildWorkFlowIndex(index);
	};

	const handleClose = () => {
		dispatch(
			setToastMessage({
				message: '',
				severity: '',
				isToastOpen: false,
			}),
		);
		setToastOpen(false);
	};

	const onChildDropData = async (e: any, droppedData: any) => {
		e.preventDefault();
		let updateParamsObj = {};
		setAllWorkflowList((prevState: any) => {
			const newState = prevState.map((obj: any) => {
				const tempInnerObj = { ...obj };
				if (obj.workflowId === droppedData.workflowId) {
					if (obj?.workflowSteps) {
						const stepsArr = obj?.workflowSteps;
						const { sortedArray, paramsObj } = swapArrayObjects(
							stepsArr,
							selectedFromObj,
							droppedData,
						);
						tempInnerObj.workflowSteps = sortedArray;
						updateParamsObj = paramsObj;
					}
					return tempInnerObj;
				}
				return tempInnerObj;
			});
			return newState;
		});
		const resp: any = await updatedWorkflowStepOrder(
			updateParamsObj,
			droppedData.workflowId,
		);
		setToastOpen(false);
		if (resp?.statusCode === OK) {
			setChildHoverIcon(false);
		} else {
			setAllWorkflowList((prevState: any) => {
				const newState = prevState.map((obj: any) => {
					const tempInnerObj = { ...obj };
					if (obj.workflowId === droppedData.workflowId) {
						const stepsArr = obj?.workflowSteps;
						const { sortedArray, paramsObj } = swapArrayObjects(
							stepsArr,
							droppedData,
							selectedFromObj,
						);
						tempInnerObj.workflowSteps = sortedArray;
						updateParamsObj = paramsObj;
						return tempInnerObj;
					}
					return tempInnerObj;
				});
				return newState;
			});
			setToastOpen(true);
			dispatch(
				setToastMessage({
					message: APP_GENERAL_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};

	const onHideChildListIcons = () => {
		setChildHoverIcon(false);
		setSelectedChildWorkFlowIndex('');
	};
	const innerTable = (props: any) => (
		<CommonTable
			rows={props?.workflowSteps}
			columns={workflowStepsColumns}
			defaultSortKey=""
			tableStyles={{
				minWidth: '44em !important',
				maxHeight: '20em !important',
				minHeight: '20em !important',
			}}
			hidePagination
			enableHeaderColor
			enableInnerTableRow
		/>
	);

	const getAlertText = (data: string) => {
		const alertText = `${DELETE_CONFIRMATION}${data} workflow step?`;
		return alertText;
	};

	useEffect(() => {
		if (createWorkflowStepFlag) {
			getAllWorkFlowList(tableQueryObj);
			dispatch(setWorkflowStepFlag(false));
		}
	}, [createWorkflowStepFlag]);
	return (
		<div className={styles['workflow-list-container']}>
			<TableComponent
				defaultQuery={tableQueryObj}
				rows={allWorkflowList}
				columns={workflowListColumns}
				totalItems={totalRecordsCount}
				totalPagesCount={totalPagesCount}
				defaultSortKey=""
				onPageHandler={handlePageChange}
				onSortHandler={handleSortChange}
				isLoading={isLoading}
				tableStyles={{
					minWidth: '46.875em',
					maxHeight: allWorkflowList * 30,
					minHeight: allWorkflowList * 30,
				}}
				enableHeaderColor
				enableInnerTableRow
				enableInnerTableTemplate={innerTable}
				colSpan={3}
				isRenderPagination
			/>
			<AlertComponent
				open={isToastOpen}
				toastMessage={message ?? ''}
				severity={severity ?? ''}
				handleCloseMessage={handleClose}
				vertical="top"
				horizontal="right"
			/>

			{openWorkflowDrawer && (
				<SideDrawer
					className={styles['create-workflow-drawer']}
					drawerState={openWorkflowDrawer}
				>
					<WorkflowStep />
				</SideDrawer>
			)}

			{openActionsModal && (
				<ActionsPrompt
					mainTitleCss={styles['createworkflowactions-prompt-main-title']}
					mainTitle={DELETE_TITLE}
					openModal={openActionsModal}
					onCloseModal={cancelHandler}
					data={selectedWorkFlowStep}
					subTitle={getAlertText(selectedWorkFlowStep?.workflowStepName)}
					actionHandler={actionHandler}
					alertTemplate={
						<Alert
							icon={
								<WarningIcon
									fill={statusWarningColor}
									className={styles['actions-prompt-alert-icon']}
								/>
							}
							sx={{
								color: textColor,
								'&.MuiAlert-root': {
									background: alertBackgroundColor,
								},
								'&.MuiAlert-icon': {
									color: `${statusWarningColor} !important`,
								},
							}}
						>
							{DELETE_SUB_TITLE}
						</Alert>
					}
					buttonsLabel={[DELETE_BUTTON_CANCEL_LABEL, DELETE_BUTTON_LABEL]}
				/>
			)}
		</div>
	);
};

export default WorkflowList;
